import React, {Fragment} from 'react';

export default function CurrencySymbol({currencySymbol}) {

    return (
        <Fragment>
            {currencySymbol === '' ? 'nevyplnena mena' : currencySymbol}
        </Fragment>
    );
}